import * as React from 'react';
import { JRCAppLeftColumnProps, SectionEntry } from './JRCAppLeftColumn.types';
import {
    MenuWrapper,
    TitleMenu,
    JRCIconButtonAppLeftColumn,
    AppLeftColumnIconWrapper,
    AbsoluteContainer,
    AbsoluteContainerMinimized,
    SectionMinimizesWrapper,
    ColumnAppDefault,
    ColumnAppMinimize,
    ColumnRelativeWrapper,
    ColumnRelativeSticky,
    ColumnRelativeTransition,
} from './JRCAppLeftColumn.styles';
import { JRCAppHeader } from '../JRCAppHeader/JRCAppHeader';
import { JRCAppLeftColumnWrapperTop } from './JRCAppLeftColumn.styles';
import { JRCTabs } from '../JRCTabs/JRCTabs';
import { JRCIcon } from '../JRCIcon/JRCIcon';
import { useIntl } from 'react-intl';
import { JRCDefaultMenu } from './JRCDefaultMenu';

/**
 * @deprecated
 * /!\ This component should be use into JRCAppContainer
 * @param Component
 * @param {sections, icon, color, title, description, activeItem, callback} props, @see JRCAppLeftColumnProps interface
 * @returns JSX.Element
 */

const JRCAppLeftColumn = <T extends SectionEntry = SectionEntry>({
    Component = JRCDefaultMenu,
    ...props
}: JRCAppLeftColumnProps<T>) => {
    const clickOnItem = (index: string): void => {
        if (props.callback) props.callback(index);
    };
    const [isMinimized, setMinimized] = React.useState(false);
    const [isClosed, setClosed] = React.useState(false);
    const intl = useIntl();

    const onClick = () => {
        if (!isMinimized) {
            setMinimized(true);
            setTimeout(() => {
                setClosed(true);
            }, 400);
        } else {
            setClosed(false);
            setMinimized(false);
        }
    };

    return (
        <ColumnRelativeWrapper isMinimized={isMinimized}>
            <ColumnRelativeSticky isMinimized={isMinimized} isClosed={isClosed}>
                <ColumnRelativeTransition isMinimized={isMinimized}>
                    <ColumnAppMinimize aria-hidden={!isMinimized}>
                        <AbsoluteContainerMinimized isMinimized={isMinimized}>
                            <JRCIconButtonAppLeftColumn
                                icon="icon-angle-right"
                                type="button"
                                size="small"
                                onClick={onClick}
                                aria-label={intl.formatMessage({ id: 'AppLeftColumn_Open_Panel' })}
                                data-cy="open-panel-button"
                            />
                        </AbsoluteContainerMinimized>
                        <JRCIcon name={props.icon} variant="circle" color={props.color} size={40} />
                        <nav aria-label={intl.formatMessage({ id: 'AppLeftColumn_App_Navigation' })}>
                            <AppLeftColumnIconWrapper isMinimized={isMinimized}>
                                {props.sections &&
                                    props.sections.map((item, i) => (
                                        <SectionMinimizesWrapper key={i}>
                                            {item.entries.map((entry, k) => (
                                                <Component
                                                    key={k}
                                                    entry={entry}
                                                    isMinimized={true}
                                                    activeItem={props.activeItem}
                                                    onClick={() => clickOnItem(entry.key)}
                                                />
                                            ))}
                                        </SectionMinimizesWrapper>
                                    ))}
                            </AppLeftColumnIconWrapper>
                        </nav>
                    </ColumnAppMinimize>
                    <ColumnAppDefault aria-hidden={isMinimized} isMinimized={isMinimized} isClosed={isClosed}>
                        <JRCAppLeftColumnWrapperTop>
                            <JRCAppHeader {...props}></JRCAppHeader>
                            <AbsoluteContainer>
                                <JRCIconButtonAppLeftColumn
                                    icon="icon-angle-left"
                                    type="button"
                                    onClick={onClick}
                                    aria-label={intl.formatMessage({ id: 'AppLeftColumn_Close_Panel' })}
                                    data-cy="close-panel-button"
                                />
                            </AbsoluteContainer>
                        </JRCAppLeftColumnWrapperTop>
                        {props.sections &&
                            props.sections.map((section, index) => (
                                <MenuWrapper key={index} isMinimized={isMinimized}>
                                    {section.title && <TitleMenu>{section.title}</TitleMenu>}
                                    <JRCTabs
                                        direction="vertical"
                                        callback={(key: string) => props.callback && props.callback(key)}
                                        activeItem={props.activeItem}
                                        entries={section.entries.map((entry) => ({
                                            ...entry,
                                            label: Component({
                                                entry,
                                                onClick: () => {
                                                    /**/
                                                },
                                            }),
                                        }))}
                                    />
                                </MenuWrapper>
                            ))}
                    </ColumnAppDefault>
                </ColumnRelativeTransition>
            </ColumnRelativeSticky>
        </ColumnRelativeWrapper>
    );
};

export { JRCAppLeftColumn };
